<div>
  <div class="flex items-center justify-center h-[50px]">
    <h4 class="xl:text-xl lg:text-lg text-primary text-lg font-medium font-sans font-medium"> Media </h4>
  </div>
  <mat-dialog-content class="!pt-0">
    <div class="flex justify-between gap-1 flex-wrap w-full items-center">
      <h6 class="text-xs font-sans font-medium"> Media - {{ itemInfo.caption }}
      </h6>
    </div>
    <div class="w-full pt-2 flex flex-wrap">
      <input type="file"
        multiple #filePicker class="fileInput" style="display: none;" (change)="onSelectMedia($event)">

        <div class="w-full flex items-center justify-center">
          <div class="flex items-center justify-center flex-col h-[120px] border border-dashed border-gray-400 rounded-lg w-full cursor-pointer"
            role="button" tabindex="0"
            (click)="filePicker.click()" (keydown.enter)="filePicker.click()"
            (dragover)="onDragOver($event)" (drop)="onDrop($event, filePicker)">
            <img src="../../../../../assets/icons/upload.svg" width="32" alt="Upload" />
            <p class="font-sans font-medium text-[11px]">Drag and drop a file here or click</p>
          </div>
        </div>

        <div class="w-full pt-1 relative overflow-x-auto shadow-md sm:rounded-lg">
          @if (checklists[itemInfo.formattedItemCode].media?.length > 0) {
            <table class="w-full text-sm text-left text-xs">
              <thead class="text-gray-900 bg-gray-100">
                <tr>
                  <th scope="col" class="px-6 py-3">File Name</th>
                  <th scope="col" class="px-6 py-3">Uploaded By</th>
                  <th scope="col" class="px-6 py-3">Uploaded On</th>
                  <th scope="col" class="px-6 py-3">Action</th>
                </tr>
              </thead>
              <tbody>
                @for (fileInfo of checklists[itemInfo.formattedItemCode].media; track $index) {
                <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200">
                  <td class="px-6 py-4"><i class="fas fa-file pr-2"></i>{{fileInfo.caption}}</td>
                  <td class="px-6 py-4">{{fileInfo.uploadedByName}}</td>
                  <td class="px-6 py-4">{{fileInfo.uploadDate | date}}</td>
                  <td class="px-6 py-4">
                    <button (click)="viewFile(fileInfo)" tabindex="-1" data-toggle="tooltip" title="View" class="me-3">
                      <i class="fas fa-eye !text-primary"></i>
                    </button>
                    <button (click)="downloadFile(fileInfo)" tabindex="-1" data-toggle="tooltip" title="Download" class="me-3">
                      <i class="fas fa-download !text-primary"></i>
                    </button>
                    <button (click)="deletefile(itemInfo, fileInfo)" tabindex="-1" data-toggle="tooltip" title="Delete">
                      <mat-icon class="!text-red c-fa" svgIcon="c:trash"></mat-icon>
                    </button>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          }
        </div>
      </div>

      <mat-dialog-actions class="!px-0 flex !justify-center !pt-3">
        <button mat-flat-button color="accent" class="text-primary secondary-button" (click)="closeDialog()">Cancel</button>
      </mat-dialog-actions>
    </mat-dialog-content>
  </div>